import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'De forma inmediata en tu email tras el pago.'
}, {
  q: '¿Sirve para todo el país?',
  a: 'Sí, está diseñado bajo lineamientos NAP e INET nacionales.'
}, {
  q: '¿Se puede editar?',
  a: 'Los cuadernillos son PDF listos para imprimir. Las planificaciones (si se agregan) son editables.'
}, {
  q: '¿Es un solo pago?',
  a: 'Sí, un único pago por el acceso total.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-36">
        <h2 className="text-3xl font-bold text-center mb-8" data-id="element-37">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-38">
          {faqs.map((faq, index) => <div key={index} className="bg-primary-card border border-primary-card rounded-xl overflow-hidden" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-40">
                <span className="font-semibold text-lg" data-id="element-41">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-accent-cyan transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>

              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="px-6 pb-4 text-text-muted" data-id="element-45">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </motion.div>
    </section>;
}